export default "__VITE_ASSET__5BQ3ZwF3__"